import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
// import { useTranslation } from "react-i18next";
import HeaderTitle from "../../../../components/header/headerTitle/headerTitle";
import "./style.scss";
import { ALL_ITEM_AUTOMOTIVE } from "./itemJson";
import ItemList from "../../itemListContainer/itemList";

function Automotive(props) {
  // const { t } = useTranslation(["translation", "aboutUs"]);
  const [selectedItem, setSelectedItem] = useState([]);

  useEffect(() => {
    const jewelsParam = props.match.params.jewels;
    const filtered = ALL_ITEM_AUTOMOTIVE[0].itemList.filter(item => item.itemSelected === jewelsParam);
    setSelectedItem(filtered)
  }, [props.match.params.jewels]); 


  return (
    <>
      <Helmet>
        <title>Automotive | Lussopack</title>
        <meta name="description" content="Automotive | Lussopack" />
        <meta name="keywords" content="Automotive | Lussopack" />
        <meta name="robots" content="noindex" />
        <link rel="canonical" href="https://lussopack.com/packaging/customized-projects/automotive/" />
      </Helmet>

      <HeaderTitle
        {...props}
        textHeader={"Customized Projects"}
        textSubHeader={"We are here to turn your dream of impeccable luxury packaging into a tangible reality."}    
      />          
      <ItemList 
        selectedItem={selectedItem}
      />
    </>
  );
}

export default Automotive;
